export default __webpack_public_path__ + "static/media/psc.d5025e18.png";